@if (platformBrowser) {
  <router-outlet></router-outlet>
  <div
    class="view-gallery-page"
    [style.--gallery-background-color]="gallery.layout_background_color || 'white'"
    [class.dark]="darkGalleryBackground"
  >
    <app-view-gallery-header
      [gallery]="gallery"
      [accessLevel]="accessLevel"
      [mode]="'layout'"
      (onFilterChange)="onFilter($event)"
      #header
    ></app-view-gallery-header>
    @if (gallery.cover.uuid && accessLevel !== 'view_only') {
      <div class="header-gradient"></div>
    }
    @if (gallery.cover.uuid || gallery.title || gallery.description) {
      <div
        class="cover-container"
        [class.has-asset]="gallery.cover.uuid"
        [style.--color-primary]="gallery.primary_color"
      >
        <div
          class="cover size-{{ gallery.cover.uuid ? gallery.cover.size : 'none' }}"
          [class.content-left]="gallery.cover.content_position?.[0] === 0"
          [class.content-right]="gallery.cover.content_position?.[0] === 1"
          [class.content-top]="gallery.cover.content_position?.[1] === 0"
          [class.content-bottom]="gallery.cover.content_position?.[1] === 1"
        >
          @if (gallery.cover?.uuid) {
            <div class="cover-asset" #el>
              @if (!gallery.cover.video_origin) {
                <app-gallery-picture
                  [uuid]="gallery.cover?.uuid"
                  [position]="gallery.cover.position"
                  [cover]="true"
                  [sourceWidth]="gallery.cover.width"
                  [sourceHeight]="gallery.cover.height"
                  [extension]="gallery.cover.ext"
                ></app-gallery-picture>
              }
              @if (gallery.cover.video_origin) {
                <app-video-viewer
                  [videoData]="$any(gallery.cover)"
                  [uuid]="gallery.cover.video_origin | videoOrigin: 'uuid'"
                  [origin]="gallery.cover.video_origin | videoOrigin: 'origin'"
                  [poster]="
                    gallery.cover?.uuid
                      | galleryCoverUrl
                        : gallery.cover.width
                        : gallery.cover.height
                        : gallery.cover.width
                        : gallery.cover.height
                        : 'jpg'
                      | async
                  "
                  [active]="true"
                  [showUi]="false"
                  [autoplay]="true"
                  [muted]="true"
                  [loop]="true"
                  [cover]="true"
                  [coverPosition]="gallery.cover.position"
                  [targetWidth]="el.clientWidth"
                ></app-video-viewer>
              }
            </div>
          }
          @if (gallery.cover?.uuid) {
            <div class="cover-overlay" [style.backgroundColor]="gallery.cover?.overlay_color || 'transparent'"></div>
          }
          <div class="cover-content">
            @if (gallery.title) {
              <h1
                [style.color]="
                  gallery.cover.title_typography?.font_color || gallery.default_title_typography?.font_color
                "
                [style.fontFamily]="
                  (gallery.cover.title_typography?.font_family || gallery.default_title_typography?.font_family) +
                  ', AkkuratLL'
                "
                class="{{ getFontSize(gallery.cover?.title_typography?.font_size) }}"
              >
                {{ gallery.title }}
              </h1>
            }
            @if (gallery.description) {
              <h3
                [style.color]="
                  gallery.cover.paragraph_typography?.font_color || gallery.default_paragraph_typography?.font_color
                "
                [style.fontFamily]="
                  (gallery.cover.paragraph_typography?.font_family ||
                    gallery.default_paragraph_typography?.font_family) + ', AkkuratLL'
                "
                class="{{ getFontSize(gallery.cover?.paragraph_typography?.font_size) }}"
                [innerHTML]="gallery.description"
              ></h3>
            }
          </div>
        </div>
      </div>
    }
    @if (!gallery.cover.uuid && !gallery.title && !gallery.description) {
      <div class="no-cover-spacer"></div>
    }
    <div #galleryBody class="content-container">
      <div>
        @if (noAssetsResult) {
          <div class="no-results" [class.dark]="darkGalleryBackground">
            <h3>No assets found</h3>
            <button
              (click)="resetFilter()"
              appButton
              color="default-opacity"
              name="reset-view-search-filter"
              location="view-gallery-page"
              shape="round"
              [center]="true"
            >
              Reset Filter
            </button>
          </div>
        }
        @if (sections$ | async; as sections) {
          @for (section of sections | sortBy: 'position'; track section.id; let i = $index) {
            @if (section.object === 'gallery' && !filters.length) {
              <div class="page section-page album-section-page">
                <app-album-section [section]="section" [parentGallery]="gallery"></app-album-section>
              </div>
            }
            @if (section.object === 'text' && !filters.length) {
              <div class="page full section-page text-section-page">
                <app-text-section
                  [section]="section"
                  [gallery]="gallery"
                  [darkGalleryBackground]="darkGalleryBackground"
                ></app-text-section>
              </div>
            }
            @if (section.object === 'asset' && section.position !== 612512) {
              <app-assets-section
                [section]="section"
                [gallery]="gallery"
                [accessLevel]="accessLevel"
                [filters]="filters"
                [darkGalleryBackground]="darkGalleryBackground"
              >
              </app-assets-section>
            }
            @if (section.object === 'embed' && !filters.length) {
              <app-embed-section [section]="section" [gallery]="gallery"> </app-embed-section>
            }
          }
        }
      </div>
    </div>
    <div class="gallery-footer brand">
      <app-tenant-logo-and-contacts
        [tenant]="tenant"
        [link]="['/']"
        [small]="true"
        [darkBg]="darkGalleryBackground"
      ></app-tenant-logo-and-contacts>
      @if (
        (!gallery || gallery.tenant?.['picflow_branding_enabled']) && gallery['tenant_product_name'] !== 'Picflow Free'
      ) {
        <app-made-with-picflow-button [tenantId]="tenant.id" [darkBackground]="darkGalleryBackground">
        </app-made-with-picflow-button>
      }
    </div>
  </div>
  @if (gallery?.approval_limits) {
    <app-approval-limit-info [gallery]="gallery"></app-approval-limit-info>
  }
}
